import React, { useEffect, useState } from "react";
import { IPage } from "api/entities/page";
import { IEnterpriseUser, IEnterpriseUserRequestParams } from "api/entities/enterprise-user";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { useApi } from "utils/hooks/use-api";
import { enterpriseUserService } from "api/services/enterprise-user-service";
import { UserTable } from "components/settings/user-table/user-table";
import { SettingsTab } from "../../shared-ui/tabs/tabs";

export function EnterpriseUserTab(props: { activeTab: SettingsTab }) {
    const [api, isLoading] = useApi();

    const [userPage, setUserPage] = useState<IPage<IEnterpriseUser>>(getEmptyPage());
    const [requestParams, setRequestParams] = useState<IEnterpriseUserRequestParams>({ ...getDefaultRequestParams(), deleted: false });

    function fetchData(requestParamsUpdate: Partial<IEnterpriseUserRequestParams>) {
        const updatedRequestParams = { ...requestParams, ...requestParamsUpdate };
        setRequestParams(updatedRequestParams);
        api(enterpriseUserService.getPage(updatedRequestParams)).then(setUserPage);
    }

    useEffect(() => {
        if (props.activeTab === SettingsTab.EnterpriseUser) {
            fetchData({});
        }

        // eslint-disable-next-line
    }, [props.activeTab]);

    return (
        <UserTable
            isLoading={isLoading}
            requestParams={requestParams}
            onRequestParamsChanged={fetchData}
            page={userPage}
        />
    );
}

